import axios from "axios";
import { ApiURL } from "../constants/ApiUrl";
// const API_URL = "http://localhost:5000/api/"
// import {useHistory} from 'react-router-dom'

const login = (username, password, str) => {
  return axios
    .post(ApiURL + "/api/admin/login", {
      username,
      password,
      str,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
        console.log(response, "hhhhhhhhhhhhhhhhhhhhh");
      }

      return response.data;
    });
};
const memLogin = (memNo, password) => {
  return axios
    .post(ApiURL + "/api/membership_login", {
      memNo,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("users", JSON.stringify(response.data));
      }
      // console.log(response.data);
      // alert(response.data.msg,"jj")
      return response.data;
    })
    .catch((err) => {
      return err;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const authHeader = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.accessToken) {
    return { Authorization: "Bearer " + user.accessToken };
  } else {
    return {};
  }
};
// const authHeaders = () => {
//     const users = JSON.parse(localStorage.getItem("users"));
//     if(users && users.accessToken){
//         return { Authorization: 'Bearer ' + users.accessToken }
//     }
//     else {
//         return {};
//     }
// }

const resetPassword = (password) => {
  return axios
    .post(
      ApiURL + "/api/reset_password",
      {
        password,
      },
      {
        headers: authHeader(),
      }
    )
    .then((response) => {
      return response.data;
    });
};

const memberResetPassword = (password, mem_no) => {
  return axios
    .post(ApiURL + "/api/member_resetPass", {
      password,
      mem_no,
      // },{
      //     headers:
      //     authHeaders()
    })
    .then((response) => {
      return response.data;
    });
};

const forgotPassword = (email) => {
  return axios
    .post(ApiURL + "/api/Forgot_password", {
      email,
    })
    .then((response) => {
      // const history = useHistory();
      alert(response.data);
      // history.push('/send_OTP')
      return response.data;
      // }).catch((err)=>{
      //     console.log(err)
      //     return err
    });
};
const memForgetPass = (email) => {
  return axios
    .post(ApiURL + "/api/Forgot_password_member_login", {
      email,
    })
    .then((response) => {
      // const history = useHistory();
      alert(response.data);
      // history.push('/send_OTP')
      return response.data;
      // }).catch((err)=>{
      //     console.log(err)
      //     return err
    });
};
const MembercheckOTP = (OTP) => {
  return axios
    .post(ApiURL + "/api/varify_OTP_for_member_login", {
      OTP,
    })
    .then((response) => {
      console.log(response.data);
      alert(response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
const checkOTP = (OTP) => {
  return axios
    .post(ApiURL + "/api/varify_OTP", {
      OTP,
    })
    .then((response) => {
      console.log(response.data);
      alert(response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
const MembernewPassword = (password1, password2) => {
  // console.log(password1,password2,"9999999999")
  return axios
    .post(ApiURL + "/api/new_pass_member_login", {
      password1,
      password2,
    })
    .then((response) => {
      alert(response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
const newPassword = (password1, password2) => {
  // console.log(password1,password2,"9999999999")
  return axios
    .post(ApiURL + "/api/new_pass", {
      password1,
      password2,
    })
    .then((response) => {
      alert(response.data);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

// 21 oct jyoti
// make function for Set Email & password
const SetEmailPass = (email, password) => {
  return axios
    .post(ApiURL + "/api/set_email_pass", {
      email,
      password,
    })
    .then((response) => {
      console.log(response.data, "ppppppppppppp");
      // alert(response.data.msg)
      return response.data.msg;
    })
    .catch((err) => {
      console.log(err);
    });
};

const getEmailPass = () => {
  return axios
    .post(ApiURL + "/api/get_api")
    .then((response) => {
      console.log(response, "ressssss");
      // alert(response.data,"jj****")
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

//eslint-disable-next-line
export default {
  login,
  logout,
  authHeader,
  MembercheckOTP,
  MembernewPassword,
  memForgetPass,
  resetPassword,
  forgotPassword,
  checkOTP,
  newPassword,
  SetEmailPass,
  getEmailPass,
  memLogin,
  memberResetPassword,
};
